import { useCallback } from "react";
import { useAuth } from "@clerk/clerk-react";

export function useApiAuth() {
  const { getToken, isSignedIn } = useAuth();

  const acquireToken = useCallback(async () => {
    if (!isSignedIn) {
      return null;
    }

    try {
      // Use custom JWT template with email and name claims
      const token = await getToken({ template: "sportex100-api" });
      return token;
    } catch (error) {
      console.error("Failed to acquire token", error);
      return null;
    }
  }, [getToken, isSignedIn]);

  return { acquireToken };
}
